import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=1d048d64&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d048d64')) {
      api.createRecord('1d048d64', component.options)
    } else {
      api.reload('1d048d64', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=1d048d64&", function () {
      api.rerender('1d048d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qxQ48fZ0VYR9/JS/comp/openstreetmap.vue"
export default component.exports